(function () {
  'use strict';

  var CARD_SELECTOR = '.lbx-blog-product-card[data-product-handle]';
  var INITIALIZED_ATTRIBUTE = 'data-lbx-product-card-ready';
  var productStore = {};
  var enhancementTimer = null;
  var I18N = window.LABOSCH_BLOG_I18N || {};

  function i18n(key, fallback) {
    var value = I18N[key];
    return value == null || value === '' ? String(fallback || '') : String(value);
  }

  function i18nTemplate(key, fallback, values) {
    var output = i18n(key, fallback);
    Object.keys(values || {}).forEach(function (name) {
      output = output.split('__' + String(name).toUpperCase() + '__').join(String(values[name] == null ? '' : values[name]));
    });
    return output;
  }

  function routesRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function trimSlashes(value) {
    return String(value || '').replace(/^\/+|\/+$/g, '');
  }

  function cleanHandle(value) {
    var handle = String(value || '').trim();
    if (!handle) return '';

    try {
      if (/^https?:\/\//i.test(handle)) {
        handle = new URL(handle).pathname;
      }
    } catch (error) {
      return '';
    }

    handle = handle.split('?')[0].split('#')[0];
    var productMatch = handle.match(/(?:^|\/)products\/([^/]+)/i);
    if (productMatch) handle = productMatch[1];

    return trimSlashes(handle).replace(/[^a-zA-Z0-9_-]/g, '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function articleCampaign() {
    var root = document.querySelector('[data-lbx-article-handle]');
    var value = root && root.getAttribute('data-lbx-article-handle');
    if (value) return value;
    var parts = window.location.pathname.split('/').filter(Boolean);
    return parts[parts.length - 1] || 'blog';
  }

  function productUrl(product, handle) {
    var base = product && product.url ? product.url : routesRoot() + 'products/' + encodeURIComponent(handle);
    var url;

    try {
      url = new URL(base, window.location.origin);
      url.searchParams.set('utm_source', 'blog');
      url.searchParams.set('utm_medium', 'organic');
      url.searchParams.set('utm_campaign', articleCampaign());
      url.searchParams.set('utm_content', handle);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return routesRoot() + 'products/' + encodeURIComponent(handle);
    }
  }

  function activeCurrency() {
    var article = document.querySelector('[data-lbx-currency]');
    return (article && article.getAttribute('data-lbx-currency')) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'EUR';
  }

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    var locale = document.documentElement.lang || 'es-ES';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: activeCurrency(),
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + activeCurrency();
    }
  }


  function normalizeKey(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function uniqueValues(values) {
    return (values || []).map(String).filter(function (value, index, array) {
      return value && array.indexOf(value) === index;
    });
  }

  function findProductOption(product, terms) {
    return usefulOptions(product).find(function (option) {
      var name = normalizeKey(option && option.name);
      return terms.some(function (term) { return name.indexOf(term) !== -1; });
    }) || null;
  }

  function formatBatteryValue(value) {
    var text = String(value || '').trim();
    if (/^\d{3,4}$/.test(text)) return text + ' Wh';
    return text;
  }

  function compactValues(values, formatter) {
    var formatted = uniqueValues(values).map(function (value) {
      return formatter ? formatter(value) : value;
    });

    if (formatted.length <= 5) return formatted.join(' · ');
    return formatted.slice(0, 5).join(' · ') + ' +' + (formatted.length - 5);
  }

  function productPriceSummary(product) {
    var available = (product.variants || []).filter(function (variant) { return variant.available; });
    var pool = available.length ? available : (product.variants || []);
    var prices = pool.map(function (variant) { return Number(variant.price || 0); }).filter(Boolean);
    var compares = pool.map(function (variant) { return Number(variant.compare_at_price || 0); }).filter(Boolean);
    var minimum = prices.length ? Math.min.apply(Math, prices) : Number(product.price || 0);
    var compare = compares.length ? Math.max.apply(Math, compares) : 0;
    var discount = compare > minimum ? Math.round(((compare - minimum) / compare) * 100) : 0;

    return {
      minimum: minimum,
      compare: compare,
      discount: discount,
      varies: Boolean(product.price_varies || (prices.length && Math.max.apply(Math, prices) !== minimum))
    };
  }

  function productMeta(product) {
    var battery = findProductOption(product, ['bateria', 'battery', 'batterie', 'akku', 'batteria', 'wh']);
    var size = findProductOption(product, ['talla', 'size', 'taille', 'grosse', 'rahmen', 'tamanho', 'quadro', 'taglia', 'telaio', 'cuadro', 'frame']);

    return {
      battery: battery ? compactValues(battery.values, formatBatteryValue) : '',
      size: size ? compactValues(size.values) : ''
    };
  }

  function fitMessage(product) {
    var context = normalizeKey([
      product.title,
      product.type,
      product.vendor,
      Array.isArray(product.tags) ? product.tags.join(' ') : product.tags
    ].join(' '));

    if (/(cargo|cargobike|wonderwagen|pickup)/.test(context)) {
      return i18n('fitCargo', 'You want an eBike for carrying cargo or family use and want to check the available configurations.');
    }

    if (/(plegable|folding|foldable|electric g line)/.test(context)) {
      return i18n('fitFolding', 'You prioritize compact mobility, easy storage and choosing the right available configuration.');
    }

    if (/(gravel|allroad)/.test(context)) {
      return i18n('fitGravel', 'You want to combine asphalt and tracks and compare the available configuration before deciding.');
    }

    if (/(trekking|touring|urbana|urban|city|commuter)/.test(context)) {
      return i18n('fitTrekking', 'You want a versatile eBike for commuting, rides and everyday use.');
    }

    if (/(enduro|game 160|riot|clutch|allmtn)/.test(context)) {
      return i18n('fitEnduro', 'You want an eMTB for demanding mountain rides and need the right configuration.');
    }

    if (/(montana|mountain|trail|emtb|moterra|jam|thron|alltrail|alltrack)/.test(context)) {
      return i18n('fitMountain', 'You want an eMTB for mountain rides and want to compare size, battery and availability before buying.');
    }

    return i18n('fitDefault', 'You want to compare price, configuration and current availability before choosing your eBike.');
  }

  function imageSource(product, variant) {
    var featured = variant && variant.featured_image;
    if (featured && typeof featured === 'object' && featured.src) return featured.src;
    if (typeof featured === 'string') return featured;
    if (product && product.featured_image) return product.featured_image;
    if (product && product.images && product.images[0]) return product.images[0];
    return '';
  }

  function normalizedOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options.map(String);
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value != null;
    }).map(String);
  }

  function usefulOptions(product) {
    var options = Array.isArray(product.options) ? product.options : [];
    return options.filter(function (option, index) {
      var name = String(option && option.name ? option.name : '').toLowerCase();
      var values = option && Array.isArray(option.values) ? option.values : [];
      if (name === 'title' && values.length === 1 && String(values[0]).toLowerCase() === 'default title') return false;
      return product.variants.some(function (variant) {
        return normalizedOptions(variant)[index] != null;
      });
    });
  }

  function optionValue(option, index, variant) {
    var values = normalizedOptions(variant);
    return values[index] != null ? String(values[index]) : '';
  }

  function selectedVariant(card, product) {
    var selects = Array.prototype.slice.call(card.querySelectorAll('[data-lbx-product-option-index]'));
    var selected = selects.map(function (select) { return select.value; });

    if (!selects.length) {
      return product.variants.find(function (variant) { return variant.available; }) || product.variants[0] || null;
    }

    return product.variants.find(function (variant) {
      var values = normalizedOptions(variant);
      return selected.every(function (value, index) { return values[index] === value; });
    }) || null;
  }

  function stabilizeProductImage(image) {
    if (!image) return;

    var markLoaded = function () {
      image.classList.add('is-loaded');
    };

    image.classList.remove('is-loaded');

    if (image.complete && image.naturalWidth > 0) {
      markLoaded();
      return;
    }

    image.addEventListener('load', markLoaded, { once: true });
    image.addEventListener('error', markLoaded, { once: true });
  }

  function updateCard(card, product, productLink) {
    var variant = selectedVariant(card, product);
    var price = card.querySelector('[data-lbx-product-price]');
    var pricePrefix = card.querySelector('[data-lbx-product-price-prefix]');
    var compare = card.querySelector('[data-lbx-product-compare]');
    var discount = card.querySelector('[data-lbx-product-discount]');
    var saving = card.querySelector('[data-lbx-product-saving]');
    var button = card.querySelector('[data-lbx-product-add]');
    var status = card.querySelector('[data-lbx-product-status]');
    var image = card.querySelector('[data-lbx-product-image]');

    if (!variant) {
      if (button) {
        button.disabled = true;
        button.textContent = i18n('combinationUnavailable', 'Combination unavailable');
      }
      if (status) status.textContent = i18n('selectOtherCombination', 'Select another combination.');
      return;
    }

    var currentPrice = Number(variant.price || 0);
    var compareAt = Number(variant.compare_at_price || 0);
    var discountPercent = compareAt > currentPrice
      ? Math.round(((compareAt - currentPrice) / compareAt) * 100)
      : 0;

    if (price) price.textContent = money(currentPrice);
    if (pricePrefix) pricePrefix.textContent = product.price_varies ? i18n('configPrice', 'Price for this configuration') : i18n('currentPrice', 'Current price');

    if (compare) {
      compare.textContent = compareAt > currentPrice ? money(compareAt) : '';
      compare.hidden = !(compareAt > currentPrice);
    }

    if (discount) {
      discount.textContent = discountPercent ? '-' + discountPercent + '%' : '';
      discount.hidden = !discountPercent;
    }

    if (saving) {
      saving.textContent = discountPercent ? i18n('save', 'Save') + ' ' + money(compareAt - currentPrice) : '';
      saving.hidden = !discountPercent;
    }

    if (image) {
      var nextImage = imageSource(product, variant);
      if (nextImage && image.getAttribute('src') !== nextImage) {
        image.classList.remove('is-loaded');
        image.src = nextImage;
      }
      image.alt = product.title + (variant.title && variant.title !== 'Default Title' ? ' – ' + variant.title : '');
      stabilizeProductImage(image);
    }

    if (button) {
      button.disabled = !variant.available;
      button.setAttribute('data-variant-id', String(variant.id || ''));
      button.textContent = variant.available ? i18n('addToCart', 'Add to cart') : i18n('temporarilySoldOut', 'Temporarily sold out');
    }

    if (status) {
      status.className = 'lbx-blog-product-card__status';
      status.textContent = variant.available
        ? i18n('availableOnline', 'Available online. Check size, battery and delivery before completing your purchase.')
        : i18n('variantUnavailable', 'This variant is currently unavailable.');
    }

    var viewLinks = card.querySelectorAll('[data-lbx-product-link]');
    viewLinks.forEach(function (link) {
      var url = new URL(productLink, window.location.origin);
      if (variant.id) url.searchParams.set('variant', variant.id);
      link.href = url.pathname + url.search;
    });

    scheduleArticleEnhancements();
  }

  function optionMarkup(product) {
    var options = usefulOptions(product);
    if (!options.length) return '';

    return '<div class="lbx-blog-product-card__options">' + options.map(function (option, index) {
      var values = option.values || [];
      var availableVariant = product.variants.find(function (variant) { return variant.available; }) || product.variants[0];
      var selected = optionValue(option, index, availableVariant);
      var optionLabel = option.name || i18nTemplate('optionIndex', 'Option __INDEX__', { index: index + 1 });
      return '<div class="lbx-blog-product-card__field">' +
        '<span>' + escapeHtml(optionLabel) + '</span>' +
        '<div class="lbx-blog-product-card__custom-select" data-lbx-blog-custom-select>' +
          '<button class="lbx-blog-product-card__select-trigger" type="button" aria-haspopup="listbox" aria-expanded="false" data-lbx-blog-select-trigger>' +
            '<span data-lbx-blog-select-value>' + escapeHtml(selected) + '</span>' +
            '<span class="lbx-blog-product-card__select-chevron" aria-hidden="true"></span>' +
          '</button>' +
          '<div class="lbx-blog-product-card__select-menu" role="listbox" hidden data-lbx-blog-select-menu>' +
            values.map(function (value) {
              var stringValue = String(value);
              return '<button type="button" class="lbx-blog-product-card__select-option" role="option" data-lbx-blog-select-option data-value="' + escapeHtml(stringValue) + '" aria-selected="' + (stringValue === selected ? 'true' : 'false') + '">' + escapeHtml(stringValue) + '</button>';
            }).join('') +
          '</div>' +
          '<select class="lbx-blog-product-card__select" data-lbx-product-option-index="' + index + '" tabindex="-1" aria-hidden="true">' +
            values.map(function (value) {
              var stringValue = String(value);
              return '<option value="' + escapeHtml(stringValue) + '"' + (stringValue === selected ? ' selected' : '') + '>' + escapeHtml(stringValue) + '</option>';
            }).join('') +
          '</select>' +
        '</div>' +
      '</div>';
    }).join('') + '</div>';
  }

  function closeBlogCustomSelect(wrapper) {
    if (!wrapper) return;
    var trigger = wrapper.querySelector('[data-lbx-blog-select-trigger]');
    var menu = wrapper.querySelector('[data-lbx-blog-select-menu]');
    wrapper.classList.remove('is-open', 'is-up');
    if (menu) menu.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAllBlogCustomSelects(except) {
    document.querySelectorAll('[data-lbx-blog-custom-select].is-open').forEach(function (wrapper) {
      if (wrapper !== except) closeBlogCustomSelect(wrapper);
    });
  }

  function enhanceBlogCustomSelects(card) {
    card.querySelectorAll('[data-lbx-blog-custom-select]').forEach(function (wrapper) {
      if (wrapper.dataset.lbxReady === '1') return;
      wrapper.dataset.lbxReady = '1';

      var nativeSelect = wrapper.querySelector('[data-lbx-product-option-index]');
      var trigger = wrapper.querySelector('[data-lbx-blog-select-trigger]');
      var valueNode = wrapper.querySelector('[data-lbx-blog-select-value]');
      var menu = wrapper.querySelector('[data-lbx-blog-select-menu]');
      var optionButtons = Array.prototype.slice.call(wrapper.querySelectorAll('[data-lbx-blog-select-option]'));
      if (!nativeSelect || !trigger || !menu) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var opening = menu.hidden;
        closeAllBlogCustomSelects(wrapper);
        if (!opening) {
          closeBlogCustomSelect(wrapper);
          return;
        }

        menu.hidden = false;
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');

        requestAnimationFrame(function () {
          var rect = trigger.getBoundingClientRect();
          var menuHeight = Math.min(menu.scrollHeight || 220, 240);
          var roomBelow = window.innerHeight - rect.bottom;
          wrapper.classList.toggle('is-up', roomBelow < menuHeight + 18 && rect.top > menuHeight + 18);
        });
      });

      optionButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var nextValue = button.getAttribute('data-value') || '';
          nativeSelect.value = nextValue;
          if (valueNode) valueNode.textContent = nextValue;
          optionButtons.forEach(function (item) {
            item.setAttribute('aria-selected', item === button ? 'true' : 'false');
          });
          closeBlogCustomSelect(wrapper);
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          trigger.focus({ preventScroll: true });
        });
      });
    });
  }

  function metaMarkup(product) {
    var meta = productMeta(product);
    var items = [];

    if (meta.battery) {
      items.push('<span class="lbx-blog-product-card__meta-item"><strong>' + escapeHtml(i18n('battery', 'Battery')) + '</strong>' + escapeHtml(meta.battery) + '</span>');
    }

    if (meta.size) {
      items.push('<span class="lbx-blog-product-card__meta-item"><strong>' + escapeHtml(i18n('sizes', 'Available sizes')) + '</strong>' + escapeHtml(meta.size) + '</span>');
    }

    if (!items.length && product.type) {
      items.push('<span class="lbx-blog-product-card__meta-item"><strong>' + escapeHtml(i18n('type', 'Type')) + '</strong>' + escapeHtml(product.type) + '</span>');
    }

    return items.length
      ? '<div class="lbx-blog-product-card__meta" aria-label="' + escapeHtml(i18n('configurationsAvailable', 'Available configurations')) + '">' + items.join('') + '</div>'
      : '';
  }

  function render(card, product, handle) {
    var productLink = productUrl(product, handle);
    var firstVariant = product.variants.find(function (variant) { return variant.available; }) || product.variants[0] || null;
    var image = imageSource(product, firstVariant);
    var kicker = card.getAttribute('data-product-kicker') || i18n('availableAt', 'Available at LaBosch');
    var viewLabel = card.getAttribute('data-product-view-label') || i18n('viewPriceSizes', 'View price, sizes and availability');

    card.id = 'producto-' + handle;
    card.setAttribute('data-product-title', product.title || '');

    card.innerHTML =
      '<div class="lbx-blog-product-card__media">' +
        '<span class="lbx-blog-product-card__discount" data-lbx-product-discount hidden></span>' +
        '<a class="lbx-blog-product-card__media-link" href="' + escapeHtml(productLink) + '" data-lbx-product-link aria-label="' + escapeHtml(i18nTemplate('goToProduct', 'Go to __TITLE__', { title: product.title })) + '">' +
          (image ? '<img class="lbx-blog-product-card__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" decoding="async" draggable="false" width="1000" height="800" data-lbx-product-image>' : '') +
        '</a>' +
      '</div>' +
      '<div class="lbx-blog-product-card__body">' +
        '<p class="lbx-blog-product-card__kicker">' + escapeHtml(kicker) + '</p>' +
        '<h3 class="lbx-blog-product-card__title"><a href="' + escapeHtml(productLink) + '" data-lbx-product-link>' + escapeHtml(product.title) + '</a></h3>' +
        (product.vendor ? '<p class="lbx-blog-product-card__vendor">' + escapeHtml(product.vendor) + (product.type ? ' · ' + escapeHtml(product.type) : '') + '</p>' : '') +
        '<div class="lbx-blog-product-card__price" aria-live="polite">' +
          '<span class="lbx-blog-product-card__price-label" data-lbx-product-price-prefix>' + escapeHtml(i18n('currentPrice', 'Current price')) + '</span>' +
          '<div class="lbx-blog-product-card__price-row">' +
            '<span class="lbx-blog-product-card__price-current" data-lbx-product-price></span>' +
            '<span class="lbx-blog-product-card__price-compare" data-lbx-product-compare hidden></span>' +
          '</div>' +
          '<span class="lbx-blog-product-card__saving" data-lbx-product-saving hidden></span>' +
        '</div>' +
        metaMarkup(product) +
        '<p class="lbx-blog-product-card__fit"><strong>' + escapeHtml(i18n('fitsIf', 'Especially suitable if:')) + '</strong> ' + escapeHtml(fitMessage(product)) + '</p>' +
        '<form class="lbx-blog-product-card__form" data-lbx-product-form>' +
          optionMarkup(product) +
          '<div class="lbx-blog-product-card__actions">' +
            '<button class="lbx-blog-product-card__button" type="submit" data-lbx-product-add>' + escapeHtml(i18n('addToCart', 'Add to cart')) + '</button>' +
            '<a class="lbx-blog-product-card__view" href="' + escapeHtml(productLink) + '" data-lbx-product-link>' + escapeHtml(viewLabel) + '</a>' +
          '</div>' +
          '<p class="lbx-blog-product-card__status" role="status" aria-live="polite" data-lbx-product-status></p>' +
        '</form>' +
      '</div>';

    card.removeAttribute('aria-busy');
    card.setAttribute(INITIALIZED_ATTRIBUTE, 'true');
    stabilizeProductImage(card.querySelector('[data-lbx-product-image]'));

    enhanceBlogCustomSelects(card);

    card.querySelectorAll('[data-lbx-product-option-index]').forEach(function (select) {
      // Evitar que listeners globales del tema interpreten la apertura
      // del selector como un clic fuera de un componente interactivo.
      ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (eventName) {
        select.addEventListener(eventName, function (event) {
          event.stopPropagation();
        });
      });

      select.addEventListener('change', function () {
        updateCard(card, product, productLink);
      });
    });

    var form = card.querySelector('[data-lbx-product-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart(card, product, productLink);
      });
    }

    updateCard(card, product, productLink);
  }

  async function addToCart(card, product, productLink) {
    var variant = selectedVariant(card, product);
    var button = card.querySelector('[data-lbx-product-add]');
    var status = card.querySelector('[data-lbx-product-status]');

    if (!variant || !variant.available || !variant.id) {
      updateCard(card, product, productLink);
      return;
    }

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = i18n('adding', 'Adding...');
    }
    if (status) {
      status.className = 'lbx-blog-product-card__status';
      status.textContent = '';
    }

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));

      var response = await fetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: Number(variant.id),
            quantity: 1,
            properties: {
              '_Origen': 'Blog LaBosch',
              '_Artículo': articleCampaign()
            }
          }],
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });

      var payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || i18n('addCartError', 'Could not add to cart.'));

      if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
        window.location.href = routesRoot() + 'cart';
        return;
      }

      var cart = await fetch(routesRoot() + 'cart.js', { credentials: 'same-origin' }).then(function (cartResponse) {
        return cartResponse.json();
      });
      cart.sections = payload.sections || {};

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          onSuccessDo: 'force_open_drawer',
          cart: cart
        }
      }));

      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'blog_add_to_cart',
          ecommerce: {
            currency: activeCurrency(),
            value: Number(variant.price || 0) / 100,
            items: [{ item_id: String(variant.id), item_name: product.title, item_variant: variant.title, quantity: 1 }]
          }
        });
      }

      if (status) {
        status.className = 'lbx-blog-product-card__status is-success';
        status.textContent = i18n('addedCart', 'Product added to cart.');
      }
    } catch (error) {
      if (status) {
        status.className = 'lbx-blog-product-card__status is-error';
        status.textContent = error && error.message ? error.message : i18n('addCartError', 'Could not add to cart.');
      }
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = !variant.available;
        button.textContent = variant.available ? i18n('addToCart', 'Add to cart') : i18n('temporarilySoldOut', 'Temporarily sold out');
      }
    }
  }

  function renderError(card, handle) {
    var fallback = routesRoot() + 'products/' + encodeURIComponent(handle);
    card.removeAttribute('aria-busy');
    card.classList.add('lbx-blog-product-card--error');
    card.innerHTML = escapeHtml(i18n('loadError', 'We could not load this product.')) + ' <a href="' + escapeHtml(fallback) + '">' + escapeHtml(i18n('viewStore', 'View it in the store')) + '</a>.';
  }

  async function initializeCard(card) {
    if (!card || card.getAttribute(INITIALIZED_ATTRIBUTE) === 'true') return;
    var handle = cleanHandle(card.getAttribute('data-product-handle'));
    if (!handle) return;

    card.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(routesRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) throw new Error('Product not found');
      var product = await response.json();
      if (!product || !Array.isArray(product.variants) || !product.variants.length) throw new Error('Product has no variants');
      productStore[handle] = product;
      render(card, product, handle);
      scheduleArticleEnhancements();
    } catch (error) {
      renderError(card, handle);
      scheduleArticleEnhancements();
    }
  }

  function articleCardsReady(content) {
    var cards = Array.prototype.slice.call(content.querySelectorAll(CARD_SELECTOR));
    if (!cards.length) return false;

    return cards.every(function (card) {
      return card.getAttribute(INITIALIZED_ATTRIBUTE) === 'true' || card.classList.contains('lbx-blog-product-card--error');
    });
  }

  function orderedProductSummaries(content) {
    var seen = {};
    var summaries = [];

    content.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      var handle = cleanHandle(card.getAttribute('data-product-handle'));
      var product = productStore[handle];
      if (!handle || !product || seen[handle]) return;
      seen[handle] = true;

      var price = productPriceSummary(product);
      var meta = productMeta(product);

      summaries.push({
        handle: handle,
        product: product,
        link: productUrl(product, handle),
        price: price,
        battery: meta.battery,
        size: meta.size
      });
    });

    return summaries;
  }

  function buildComparisonTable(content, summaries) {
    var existingComparison = content.querySelector('.lbx-blog-comparison');

    if (existingComparison) {
      // Mantener el comparador justo antes del FAQ sin moverlo
      // continuamente. Mover nodos en cada pasada hacía perder el
      // foco de los selectores nativos de variantes.
      var existingFaq = content.querySelector('.lbx-blog-faq');

      if (existingFaq) {
        if (existingComparison.nextElementSibling !== existingFaq) {
          content.insertBefore(existingComparison, existingFaq);
        }
      } else if (existingComparison !== content.lastElementChild) {
        content.appendChild(existingComparison);
      }

      return;
    }

    if (summaries.length < 3) return;

    var cards = summaries.map(function (item) {
      var firstVariant = (item.product.variants || []).find(function (variant) { return variant.available; }) || (item.product.variants || [])[0] || null;
      var image = imageSource(item.product, firstVariant);
      var type = item.product.type || i18n('ebikeType', 'Electric bike');
      var priceLabel = (item.price.varies ? i18n('from', 'From') + ' ' : '') + money(item.price.minimum);

      return '<article class="lbx-blog-comparison-card">' +
        '<a class="lbx-blog-comparison-card__media" href="#producto-' + escapeHtml(item.handle) + '" aria-label="' + escapeHtml(i18nTemplate('goToProduct', 'Go to __TITLE__', { title: item.product.title })) + '">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product.title) + '" loading="lazy" width="360" height="260">' : '<span class="lbx-blog-comparison-card__placeholder"></span>') +
        '</a>' +
        '<div class="lbx-blog-comparison-card__body">' +
          '<p class="lbx-blog-comparison-card__type">' + escapeHtml(type) + '</p>' +
          '<h3><a href="#producto-' + escapeHtml(item.handle) + '">' + escapeHtml(item.product.title) + '</a></h3>' +
          '<div class="lbx-blog-comparison-card__price">' +
            '<strong>' + escapeHtml(priceLabel) + '</strong>' +
            (item.price.discount ? '<span class="lbx-blog-comparison__discount">-' + item.price.discount + '%</span>' : '') +
          '</div>' +
          '<dl class="lbx-blog-comparison-card__specs">' +
            '<div><dt>' + escapeHtml(i18n('battery', 'Battery')) + '</dt><dd>' + escapeHtml(item.battery || i18n('consult', 'Ask us')) + '</dd></div>' +
            '<div><dt>' + escapeHtml(i18n('sizes', 'Available sizes')) + '</dt><dd>' + escapeHtml(item.size || i18n('consult', 'Ask us')) + '</dd></div>' +
          '</dl>' +
          '<div class="lbx-blog-comparison-card__actions">' +
            '<a class="lbx-blog-comparison-card__anchor" href="#producto-' + escapeHtml(item.handle) + '">' + escapeHtml(i18n('viewAnalysis', 'View analysis')) + '</a>' +
            '<a class="lbx-blog-comparison__link" href="' + escapeHtml(item.link) + '">' + escapeHtml(i18n('viewProduct', 'View product')) + '</a>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    var section = document.createElement('section');
    section.className = 'lbx-blog-comparison';
    section.setAttribute('aria-labelledby', 'lbx-comparison-title');
    section.innerHTML =
      '<div class="lbx-blog-comparison__header">' +
        '<div>' +
          '<p class="lbx-blog-comparison__eyebrow">' + escapeHtml(i18n('selection', 'LaBosch selection')) + '</p>' +
          '<h2 id="lbx-comparison-title">' + escapeHtml(i18n('compareTitle', 'Compare the models at a glance')) + '</h2>' +
          '<p>' + escapeHtml(i18n('compareIntro', 'Starting price, battery and available sizes to quickly identify the best fit.')) + '</p>' +
        '</div>' +
      '</div>' +
      '<div class="lbx-blog-comparison__grid">' + cards + '</div>' +
      '<p class="lbx-blog-comparison__note">' + escapeHtml(i18n('compareNote', 'Prices, variants and availability may change. Check each product page before buying.')) + '</p>';

    // Cierre comercial: siempre después de conclusión, FAQ y resto del contenido.
    content.appendChild(section);
  }

  function isFaqHeading(value) {
    var normalized = normalizeKey(value);
    var localized = normalizeKey(i18n('faqTitle', 'Frequently asked questions'));
    if (!normalized) return false;
    if (normalized === 'faq' || (localized && normalized.indexOf(localized) !== -1)) return true;
    return /(preguntas frecuentes|frequently asked questions|questions frequentes|haufig gestellte fragen|perguntas frequentes|domande frequenti|faq)/.test(normalized);
  }

  function hasFaq(content) {
    return Array.prototype.slice.call(content.querySelectorAll('h2, h3')).some(function (heading) {
      return isFaqHeading(heading.textContent || '');
    });
  }

  function buildFaq(content, summaries) {
    if (summaries.length < 3 || hasFaq(content) || content.querySelector('.lbx-blog-faq')) return;

    var category = summaries.map(function (item) { return item.product.type; }).filter(Boolean)[0] || i18n('electricBikes', 'electric bikes');
    var section = document.createElement('section');
    section.className = 'lbx-blog-faq';
    section.setAttribute('aria-labelledby', 'lbx-faq-title');
    section.innerHTML =
      '<p class="lbx-blog-faq__eyebrow">' + escapeHtml(i18n('beforeBuy', 'Before you buy')) + '</p>' +
      '<h2 id="lbx-faq-title">' + escapeHtml(i18n('faqTitle', 'Frequently asked questions')) + '</h2>' +
      '<details open><summary>' + escapeHtml(i18n('faqQ1', 'Which of these electric bikes should I choose?')) + '</summary><div><p>' + escapeHtml(i18n('faqA1', 'The right choice depends on your use, budget and required configuration.')) + '</p></div></details>' +
      '<details><summary>' + escapeHtml(i18n('faqQ2', 'Are prices and availability final?')) + '</summary><div><p>' + escapeHtml(i18n('faqA2', 'No. Prices, promotions and stock can change.')) + '</p></div></details>' +
      '<details><summary>' + escapeHtml(i18n('faqQ3', 'How do I choose the size and battery?')) + '</summary><div><p>' + escapeHtml(i18n('faqA3', 'Select the card options to check each combination.')) + '</p></div></details>' +
      '<details><summary>' + escapeHtml(i18n('faqQ4', 'Can I buy directly from this article?')) + '</summary><div><p>' + escapeHtml(i18nTemplate('faqA4', 'Yes. You can select a variant and add it to the cart, or open the product page for all details about the __CATEGORY__.', { category: category })) + '</p></div></details>';

    content.appendChild(section);
  }



  function placeFaqAtEnd(content) {
    if (!content) return;

    var comparison = content.querySelector('.lbx-blog-comparison');
    var faq = content.querySelector('.lbx-blog-faq');

    if (faq) {
      // Solo moverlo cuando realmente no sea el último elemento.
      // appendChild sobre el mismo nodo en cada ciclo generaba una
      // mutación permanente y cerraba los desplegables al perder foco.
      if (faq !== content.lastElementChild) {
        content.appendChild(faq);
      }
      return;
    }

    var faqHeading = Array.prototype.slice.call(content.querySelectorAll('h2, h3')).find(function (heading) {
      return isFaqHeading(heading.textContent || '');
    });

    if (!faqHeading) return;

    var wrapper = document.createElement('section');
    wrapper.className = 'lbx-blog-faq lbx-blog-faq--from-content';
    wrapper.setAttribute('aria-label', i18n('faqTitle', 'Frequently asked questions'));

    content.insertBefore(wrapper, faqHeading);

    var node = faqHeading;
    while (node) {
      var next = node.nextSibling;

      if (node === comparison || (node.nodeType === 1 && node.classList && node.classList.contains('lbx-blog-comparison'))) {
        break;
      }

      wrapper.appendChild(node);
      node = next;
    }

    content.appendChild(wrapper);
  }

  function topLevelArticleChild(node, content) {
    var current = node;

    while (current && current.parentElement && current.parentElement !== content) {
      current = current.parentElement;
    }

    return current && current.parentElement === content ? current : null;
  }

  function removeEmptyEditorialWrapper(node) {
    if (!node || !node.parentNode) return;

    var clone = node.cloneNode(true);
    clone.querySelectorAll(CARD_SELECTOR).forEach(function (card) { card.remove(); });

    var hasMeaningfulElement = Boolean(
      clone.querySelector('img, picture, video, iframe, table, pre, ul, ol, h2, h3, h4')
    );

    if (!hasMeaningfulElement && !String(clone.textContent || '').trim()) {
      node.remove();
    }
  }

  function promoteNestedProductCards(content) {
    if (!content) return;

    var cards = Array.prototype.slice.call(
      content.querySelectorAll(CARD_SELECTOR)
    ).reverse();

    cards.forEach(function (card) {
      if (card.closest('.lbx-blog-model-section')) return;
      if (card.parentElement === content) return;

      var topLevel = topLevelArticleChild(card, content);
      if (!topLevel || topLevel === card) return;

      // The AI can place a product marker inside a paragraph, list item,
      // blockquote or generic div. Move the rendered card back into the
      // main article flow so it can never inherit a narrow/offset box.
      topLevel.insertAdjacentElement('afterend', card);
      removeEmptyEditorialWrapper(topLevel);
    });
  }

  function wrapProductSections(content) {
    var cards = Array.prototype.slice.call(content.querySelectorAll(CARD_SELECTOR));

    cards.forEach(function (card) {
      if (card.closest('.lbx-blog-model-section')) return;

      var heading = card.previousElementSibling;
      while (heading && !/^H[23]$/.test(heading.tagName)) {
        heading = heading.previousElementSibling;
      }

      if (!heading || heading.closest('.lbx-blog-comparison, .lbx-blog-faq')) return;

      var parent = heading.parentNode;
      if (!parent || parent !== card.parentNode) return;

      var section = document.createElement('section');
      section.className = 'lbx-blog-model-section';
      section.setAttribute('aria-labelledby', heading.id || '');
      parent.insertBefore(section, heading);

      var node = heading;
      while (node) {
        var next = node.nextSibling;
        section.appendChild(node);
        if (node === card) break;
        node = next;
      }
    });
  }

  function consolidateAvailabilityCards(content) {
    var sections = Array.prototype.slice.call(
      content.querySelectorAll('.lbx-blog-model-section')
    );

    sections.forEach(function (section) {
      var heading = section.querySelector('h2, h3');
      var headingText = heading ? String(heading.textContent || '') : '';

      if (!/(modelos|bicicletas) disponibles(?: en labosch)?/i.test(headingText)) {
        return;
      }

      section.classList.add('lbx-blog-model-section--product-list');

      var next = section.nextElementSibling;
      while (next && next.matches && next.matches(CARD_SELECTOR)) {
        var current = next;
        next = next.nextElementSibling;
        section.appendChild(current);
      }
    });
  }

  function wrapOrphanProductCards(content) {
    var orphanCards = Array.prototype.slice.call(
      content.querySelectorAll(CARD_SELECTOR)
    ).filter(function (card) {
      return !card.closest('.lbx-blog-model-section');
    });

    orphanCards.forEach(function (card) {
      var parent = card.parentNode;
      if (!parent) return;

      var section = document.createElement('section');
      section.className = 'lbx-blog-model-section lbx-blog-model-section--orphan';
      parent.insertBefore(section, card);
      section.appendChild(card);
    });
  }

  function headingSlug(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80) || 'seccion';
  }

  function buildToc(content) {
    var sidebar = document.querySelector('[data-lbx-article-sidebar]');
    var list = sidebar && sidebar.querySelector('[data-lbx-toc-list]');
    if (!sidebar || !list) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3')).filter(function (heading) {
      return heading.textContent && heading.textContent.trim().length > 2;
    });

    if (headings.length < 2) {
      sidebar.hidden = true;
      return;
    }

    var used = {};
    var links = [];

    headings.forEach(function (heading, index) {
      var base = heading.id || headingSlug(heading.textContent);
      var id = base;
      var count = 2;

      while (used[id] || document.getElementById(id) && document.getElementById(id) !== heading) {
        id = base + '-' + count;
        count += 1;
      }

      used[id] = true;
      heading.id = id;

      var item = document.createElement('li');
      item.className = 'lb-article-toc__item lb-article-toc__item--' + heading.tagName.toLowerCase();
      item.innerHTML = '<a href="#' + escapeHtml(id) + '">' + escapeHtml(heading.textContent.trim()) + '</a>';
      list.appendChild(item);
      links.push({ heading: heading, link: item.querySelector('a') });
    });

    sidebar.hidden = false;

    list.addEventListener('click', function (event) {
      var anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;
      var target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', anchor.getAttribute('href'));

      var details = anchor.closest('details');
      if (details) details.open = false;
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (item) {
            item.link.classList.toggle('is-active', item.heading === entry.target);
          });
        });
      }, { rootMargin: '-20% 0px -68% 0px', threshold: 0 });

      links.forEach(function (item) { observer.observe(item.heading); });
    }
  }

  function initReadingProgress() {
    if (document.documentElement.getAttribute('data-lbx-reading-progress-ready') === 'true') return;

    var article = document.querySelector('.lb-article-page');
    var bar = document.querySelector('[data-lbx-reading-progress]');
    if (!article || !bar) return;

    document.documentElement.setAttribute('data-lbx-reading-progress-ready', 'true');

    var update = function () {
      var rect = article.getBoundingClientRect();
      var articleTop = window.scrollY + rect.top;
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var total = Math.max(1, article.offsetHeight - viewport);
      var progress = Math.min(1, Math.max(0, (window.scrollY - articleTop) / total));
      bar.style.width = (progress * 100).toFixed(2) + '%';
    };

    var ticking = false;
    var requestUpdate = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('[data-lbx-blog-custom-select]')) {
      closeAllBlogCustomSelects(null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllBlogCustomSelects(null);
  });

  function enhanceArticle() {
    var content = document.querySelector('.lb-article-content');
    if (!content) return;

    var cards = content.querySelectorAll(CARD_SELECTOR);
    if (cards.length) {
      if (!articleCardsReady(content)) {
        initReadingProgress();
        return;
      }

      var summaries = orderedProductSummaries(content);
      promoteNestedProductCards(content);
      wrapProductSections(content);
      consolidateAvailabilityCards(content);
      wrapOrphanProductCards(content);
      buildComparisonTable(content, summaries);
      buildFaq(content, summaries);
      placeFaqAtEnd(content);
    }

    var tocList = document.querySelector('[data-lbx-toc-list]');
    if (tocList && !tocList.children.length) buildToc(content);
    initReadingProgress();
  }

  function scheduleArticleEnhancements() {
    window.clearTimeout(enhancementTimer);
    enhancementTimer = window.setTimeout(enhanceArticle, 180);
  }

  function markerMatch(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .trim()
      .match(/^\[\[\s*PRODUCT\s*:\s*([a-zA-Z0-9_-]+)\s*\]\]$/i);
  }

  function createProductCard(handle) {
    var card = document.createElement('div');
    card.className = 'lbx-blog-product-card';
    card.setAttribute('data-product-handle', handle);
    return card;
  }

  function markerContainer(textNode, boundary) {
    var current = textNode.parentElement;

    while (current && current !== boundary) {
      if (current.matches && current.matches(CARD_SELECTOR)) return null;

      if (
        current.matches &&
        current.matches('p, li, blockquote, div, section') &&
        markerMatch(current.textContent)
      ) {
        return current;
      }

      current = current.parentElement;
    }

    return markerMatch(textNode.nodeValue) ? textNode : null;
  }

  function convertTextMarkers(scope) {
    if (!scope) return;

    var boundary = scope.matches && scope.matches('.lb-article-content')
      ? scope
      : (scope.querySelector && scope.querySelector('.lb-article-content'));

    if (!boundary && scope.closest) boundary = scope.closest('.lb-article-content');
    if (!boundary) return;

    var walker = document.createTreeWalker(
      boundary,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node || !node.nodeValue || node.parentElement.closest(CARD_SELECTOR)) {
            return NodeFilter.FILTER_REJECT;
          }

          return node.nodeValue.indexOf('[[PRODUCT') !== -1 ||
            node.nodeValue.indexOf('[[product') !== -1
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    var targets = [];
    var textNode;

    while ((textNode = walker.nextNode())) {
      var match = markerMatch(textNode.nodeValue) || markerMatch(textNode.parentElement.textContent);
      if (!match) continue;

      var target = markerContainer(textNode, boundary);
      if (!target) continue;

      if (!targets.some(function (item) { return item.target === target; })) {
        targets.push({ target: target, handle: match[1] });
      }
    }

    targets.forEach(function (item) {
      var card = createProductCard(item.handle);

      if (item.target.nodeType === Node.TEXT_NODE) {
        item.target.parentNode.replaceChild(card, item.target);
      } else {
        item.target.replaceWith(card);
      }
    });
  }

  function boot(scope) {
    var root = scope || document;
    convertTextMarkers(root);
    root.querySelectorAll(CARD_SELECTOR).forEach(initializeCard);
    scheduleArticleEnhancements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  var articleContent = document.querySelector('.lb-article-content');
  if (articleContent && 'MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          var isProductCard = Boolean(
            node.matches && node.matches(CARD_SELECTOR)
          );

          var containsProductCard = Boolean(
            node.querySelector && node.querySelector(CARD_SELECTOR)
          );

          var containsProductMarker = /\[\[\s*PRODUCT\s*:/i.test(
            String(node.textContent || '')
          );

          // Ignorar las mutaciones visuales internas creadas por el
          // propio script (FAQ, comparador, wrappers, etc.). Antes se
          // volvía a ejecutar boot() ante cualquier nodo añadido y se
          // generaba un ciclo de movimientos del DOM que cerraba los
          // selectores de color, batería y talla.
          if (!isProductCard && !containsProductCard && !containsProductMarker) {
            return;
          }

          if (isProductCard) initializeCard(node);
          boot(node);
        });
      });
    }).observe(articleContent, { childList: true, subtree: true });
  }
})();
